import { searchActionTypes } from '../app/enums';
import { Order } from '../models/order.interface';
import { SearchContextType, SearchType } from '../models/search.interface';

export type SearchAction =
  | { type: searchActionTypes.LOAD_SEARCH_LIST, searchList: SearchLine[] }
  | { type: searchActionTypes.LOAD_ORDER_MAP, searchOrderMap: Map<string, Order>}
  | { type: searchActionTypes.SHOW_ADD_TO_CART, vin: string, item: SearchType}
  | { type: searchActionTypes.LOAD_OPTIONAL_ITEMS_MAP, searchOptionalItemMap: Map<string, OptionalItem>}
  | { type: searchActionTypes.ADD_TO_OPTIONAL_ITEMS_MAP, searchId: string, optionalItem: OptionalItem }
  | { type: searchActionTypes.HIDE_ADD_TO_CART }

export const loadSearchList = (state: SearchContextType, searchList: SearchLine[]) => {
  return {
    ...state,
    searchList: searchList
  };
}

export const loadOrderMap = (state: SearchContextType, searchOrderMap: Map<string, Order>) => {
  return {
    ...state,
    searchOrderMap: searchOrderMap
  }
}

export const loadOptionalItemMap = (state: SearchContextType, searchOptionalItemMap: Map<string, OptionalItem>) => {
  return {
    ...state,
    searchOptionalItemMap: searchOptionalItemMap
  }
}

export const addToOptionalItemMap = (state: SearchContextType, searchId: string, item: OptionalItem) => {
  const optionalItems = state.searchOptionalItemMap === undefined 
    ? new Map<string, OptionalItem>() 
    : state.searchOptionalItemMap

  optionalItems.set(searchId, item)

  return {
    ...state, 
    searchOptionalItemMap: optionalItems
  }
}

export const setAddToCart = (state: SearchContextType, vin: string, item: SearchType) => {
  return {
    ...state, 
    addToCartVin: vin,
    addToCartItem: item,
    addToCartDialogOpen: true
  }
}

const hideAddToCart = (state: SearchContextType) => {
  return {
    ...state,
    addToCartDialogOpen: false
  }
}

export const searchReducer = (state: SearchContextType, action:SearchAction) => {
  switch (action.type){
    case searchActionTypes.LOAD_SEARCH_LIST:
      return loadSearchList(state, action.searchList.sort((itemA, itemB) => 
      (new Date(itemB.search.searchedAt)).getTime() - (new Date(itemA.search.searchedAt)).getTime()));
    case searchActionTypes.LOAD_ORDER_MAP:
      return loadOrderMap(state, action.searchOrderMap);
    case searchActionTypes.LOAD_OPTIONAL_ITEMS_MAP:
      return loadOptionalItemMap(state, action.searchOptionalItemMap);
    case searchActionTypes.ADD_TO_OPTIONAL_ITEMS_MAP:
      return addToOptionalItemMap(state, action.searchId, action.optionalItem)
    case searchActionTypes.SHOW_ADD_TO_CART:
      return setAddToCart(state, action.vin, action.item);
    case searchActionTypes.HIDE_ADD_TO_CART:
      return hideAddToCart(state);
    default:
      return state;
  }
}
  